/**
 * Grocery POI Icon - Shopping cart icon for grocery store markers
 *
 * Used in POI markers with circular colored backgrounds.
 * Original asset: GroceryStore.svg (16x16px, white fill)
 */

import React from 'react';

export type GroceryIconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

/**
 * Grocery icon SVG content for use in POI markers
 */
export const GROCERY_ICON_PATH = `<path d="M14.5029 10.0021H2.7079L3.7079 9.00206H11.7829C12.2141 9.00245 12.5971 8.72634 12.7329 8.31706L14.0629 3.81706C14.1639 3.51288 14.1129 3.17874 13.9259 2.91848C13.7388 2.65821 13.4384 2.50337 13.1179 2.50206H3.5029C3.41678 2.50317 3.33113 2.51493 3.2479 2.53706L1.8579 1.14706C1.73107 1.02023 1.54621 0.970695 1.37296 1.01712C1.19971 1.06354 1.06438 1.19887 1.01796 1.37212C0.971537 1.54537 1.02107 1.73023 1.1479 1.85706L2.5379 3.24706C2.51577 3.33029 2.50401 3.41594 2.5029 3.50206V8.00206C2.50398 8.21672 2.5741 8.42533 2.7029 8.59706L1.1479 10.1471C1.05324 10.2409 1 10.3687 1 10.5021C1 10.6354 1.05324 10.7632 1.1479 10.8571C1.24226 10.9507 1.37 11.0028 1.5029 11.0021H14.5029C14.779 11.0021 15.0029 10.7782 15.0029 10.5021C15.0029 10.2259 14.779 10.0021 14.5029 10.0021Z" fill="white"/><path d="M2.0029 13.5021C2.0029 12.6736 2.67447 12.0021 3.5029 12.0021C4.33133 12.0021 5.0029 12.6736 5.0029 13.5021C5.0029 14.3305 4.33133 15.0021 3.5029 15.0021C2.67447 15.0021 2.0029 14.3305 2.0029 13.5021Z" fill="white"/><path d="M12.5029 12.0021C11.6745 12.0021 11.0029 12.6736 11.0029 13.5021C11.0029 14.3305 11.6745 15.0021 12.5029 15.0021C13.3313 15.0021 14.0029 14.3305 14.0029 13.5021C14.0029 12.6736 13.3313 12.0021 12.5029 12.0021Z" fill="white"/>`;

/**
 * React component for grocery icon (optional, for direct usage)
 */
export const GroceryIcon: React.FC<GroceryIconProps> = ({ size = 16, color = 'currentColor', className }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M14.5029 10.0021H2.7079L3.7079 9.00206H11.7829C12.2141 9.00245 12.5971 8.72634 12.7329 8.31706L14.0629 3.81706C14.1639 3.51288 14.1129 3.17874 13.9259 2.91848C13.7388 2.65821 13.4384 2.50337 13.1179 2.50206H3.5029C3.41678 2.50317 3.33113 2.51493 3.2479 2.53706L1.8579 1.14706C1.73107 1.02023 1.54621 0.970695 1.37296 1.01712C1.19971 1.06354 1.06438 1.19887 1.01796 1.37212C0.971537 1.54537 1.02107 1.73023 1.1479 1.85706L2.5379 3.24706C2.51577 3.33029 2.50401 3.41594 2.5029 3.50206V8.00206C2.50398 8.21672 2.5741 8.42533 2.7029 8.59706L1.1479 10.1471C1.05324 10.2409 1 10.3687 1 10.5021C1 10.6354 1.05324 10.7632 1.1479 10.8571C1.24226 10.9507 1.37 11.0028 1.5029 11.0021H14.5029C14.779 11.0021 15.0029 10.7782 15.0029 10.5021C15.0029 10.2259 14.779 10.0021 14.5029 10.0021Z"
        fill={color}
      />
      <path
        d="M2.0029 13.5021C2.0029 12.6736 2.67447 12.0021 3.5029 12.0021C4.33133 12.0021 5.0029 12.6736 5.0029 13.5021C5.0029 14.3305 4.33133 15.0021 3.5029 15.0021C2.67447 15.0021 2.0029 14.3305 2.0029 13.5021Z"
        fill={color}
      />
      <path
        d="M12.5029 12.0021C11.6745 12.0021 11.0029 12.6736 11.0029 13.5021C11.0029 14.3305 11.6745 15.0021 12.5029 15.0021C13.3313 15.0021 14.0029 14.3305 14.0029 13.5021C14.0029 12.6736 13.3313 12.0021 12.5029 12.0021Z"
        fill={color}
      />
    </svg>
  );
};
